exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bar-container {\n  border-left: dashed gray 1px;\n  position: absolute;\n  top: 0;\n  left: 4px;\n  right: 4px;\n  bottom: 0;\n}\n\n.bar-container .bar {\n  background-color: #FAD5CE;\n  position: absolute;\n  top: 10%;\n  bottom: 10%;\n}\n\n.bar-container .label {\n  position: absolute;\n  bottom: 0;\n  left: 1em;\n}\n\n", ""]);

// exports
